// extracted by mini-css-extract-plugin
export default {"component":"styles__component--zdftU","icon":"styles__icon--yKW3v","pulse":"styles__pulse--yoo4r"};